import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/detail',
      name: 'detail',
      component: resolve => require(['../page/detail.vue'], resolve)
    },
    {
      path: '/baoliao',
      name: 'baoliao',
      component: resolve => require(['../page/baoliao.vue'], resolve)
    },
    {
      path: '/zhuanti',
      name: 'zhuanti',
      component: resolve => require(['../page/zhuanti.vue'], resolve)
    },
    {
      path: '/yishi',
      name: 'yishi',
      component: resolve => require(['../page/yishi.vue'], resolve)
    },
    {
      path: '/appdownload',
      name: 'appdownload',
      component: resolve => require(['../page/appdownload.vue'], resolve)
    },
    {
      path: '/approvaldetail',
      name: 'approvaldetail',
      component: resolve => require(['../page/approvalDetail.vue'], resolve)
    },
    {
      path: '/approvallist',
      name: 'approvallist',
      component: resolve => require(['../page/approvalList.vue'], resolve)
    },
    {
      path: '/approvalhistorylist',
      name: 'approvalhistorylist',
      component: resolve => require(['../page/approvalHistoryList.vue'], resolve)
    },
    {
      path: '/approvalreject',
      name: 'approvalreject',
      component: resolve => require(['../page/approvalReject.vue'], resolve)
    },
    {
      path: '/approvalagree',
      name: 'approvalagree',
      component: resolve => require(['../page/approvalAgree.vue'], resolve)
    },
    {
      path: '/approvaldetailshared',
      name: 'approvaldetailshared',
      component: resolve => require(['../page/approvalDetailShared.vue'], resolve)
    },
    {
      path: '/xiaoqudongtai',
      name: 'xiaoqudongtai',
      component: resolve => require(['../page/xiaoqudongtai.vue'], resolve)
    },
    {
      path: '/xiaoqudongtaishared',
      name: 'xiaoqudongtaishared',
      component: resolve => require(['../page/xiaoqudongtaiShared.vue'], resolve)
    },
    {
      path: '/xiaoqudongtaiouturl',
      name: 'xiaoqudongtaiouturl',
      component: resolve => require(['../page/xiaoqudongtaiouturl.vue'], resolve)
    },
    {
      path: '/xiaoqudongtaiouturlshared',
      name: 'xiaoqudongtaiouturlshared',
      component: resolve => require(['../page/xiaoqudongtaiouturlShared.vue'], resolve)
    },
    {
      path: '/device',
      name: 'device',
      component: resolve => require(['../page/device.vue'], resolve)
    },
    {
      path: '/wjxlogin',
      name: 'wjxlogin',
      component: resolve => require(['../page/wjxlogin.vue'], resolve)
    },
    {
      path: '/wjxpage',
      name: 'wjxpage',
      component: resolve => require(['../page/wjxpage.vue'], resolve)
    },
    {
      path: '/wjxcallback',
      name: 'wjxcallback',
      component: resolve => require(['../page/wjxcallback.vue'], resolve)
    },
    {
      path: '/wjxtips',
      name: 'wjxtips',
      component: resolve => require(['../page/wjxtips.vue'], resolve)
    },
    {
      path: '/wjxalready',
      name: 'wjxalready',
      component: resolve => require(['../page/wjxalready.vue'], resolve)
    },
    {
      path: '/shared',
      name: 'shared',
      component: resolve => require(['../page/shared.vue'], resolve)
    },
    {
      path: '/pacthtml',
      name: 'pacthtml',
      component: resolve => require(['../page/pacthtml.vue'], resolve)
    },
    {
      path: '/getCoupon',
      name: 'getCoupon',
      component: resolve => require(['../page/coupon/getCoupon.vue'], resolve)
    },
    {
      path: '/guanggaoweiurl',
      name: 'guangGaoWeiUrl',
      component: resolve => require(['../page/Advsertising/guanggaoweiUrl.vue'], resolve)
    },
    {
      path: '/guanggaoweishared',
      name: 'guanggaoweishared',
      component: resolve => require(['../page/Advsertising/guanggaoweiShared.vue'], resolve)
    },
    {
      path: '/activitySale',
      name: 'activitySale',
      component: resolve => require(['../page/ActivitySale/activitySale.vue'], resolve)
    },
    {
      path: '/activitySaleShared',
      name: 'activitySaleShared',
      component: resolve => require(['../page/ActivitySale/activitySaleShared.vue'], resolve)
    },
    {
      path: '/affairDetailShared',
      name: 'affairDetailShared',
      component: resolve => require(['../page/AffairDetail/affairDetailShared.vue'], resolve)
    },
    {
      path: '/html5',
      name: 'html5',
      component: resolve => require(['../page/Html/html.vue'], resolve)
    },
    {
      path: '/htmlShared',
      name: 'htmlShared',
      component: resolve => require(['../page/Html/htmlShared.vue'], resolve)
    },
    {
      path: '/postDetailShared',
      name: 'postDetailShared',
      component: resolve => require(['../page/PostDetail/postDetailShared.vue'], resolve)
    },
    {
      path: '/incomeAndExpIndex',
      name: 'incomeAndExpIndex',
      meta:{
        title: '小区账户'
      },
      component: resolve => require(['../page/IncomeAndExpend/index.vue'], resolve)
    },
    {
      path: '/incomeAndExpDetail',
      name: 'incomeAndExpDetail',
      component: resolve => require(['../page/IncomeAndExpend/detail.vue'], resolve)
    },
    {
      path: '/luckyDraw',
      name: 'luckyDraw',
      component: resolve => require(['../page/luckyDraw/luckyDraw.vue'], resolve)
    },
    {
      path: '/enterCar',
      name: 'enterCar',
      component: resolve => require(['../page/stopCharge/enterCar.vue'], resolve)
    },
    {
      path: '/paySuccess',
      name: 'paySuccess',
      component: resolve => require(['../page/stopCharge/paySuccess.vue'], resolve)
    },
    {
      path: '/codeSource',
      name: 'codeSource',
      component: resolve => require(['../page/stopCharge/codeSource.vue'], resolve)
    },
    {
      path: '/stopCharge',
      name: 'stopCharge',
      component: resolve => require(['../page/stopCharge/stopCharge.vue'], resolve)
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js